import { allColorCategoryMapping, RECHARTS_COLOR_FILLS } from 'src/features/statistic/utils/constants';

export const getFillColor = (key: string, index: number) => {
    return allColorCategoryMapping[key] ?? RECHARTS_COLOR_FILLS[index % RECHARTS_COLOR_FILLS.length];
};
